import { ArticleCategories } from "@modules";
import { Breadcrumb } from "@components";
import { useParams } from "react-router-dom";

export default function EditPage() {
  const { id } = useParams();

  return (
    <div className="container max-content">
      <Breadcrumb
        data={[
          { title: "Article Categories", href: "/article_categories" },
          { title: "Edit Category", href: `/article_categories/edit/${id}` },
        ]}
      />
      <h1 className="mb-8 text-3xl">Edit Category</h1>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <ArticleCategories.Edit id={id} />
        </div>
      </div>
    </div>
  );
}
